import SnippetDefinition from "./Snippet/definition";
import DatasetExamplesDefinition from "./DatasetExamples/definition";
import { TagDefinition } from "./Tag";
import { ContentNodeDefinition } from "./types";

const ContentNodeDefinitions: ContentNodeDefinition[] = [
  TagDefinition,
  SnippetDefinition,
  DatasetExamplesDefinition,
];

export default ContentNodeDefinitions;
